<template>
  <InfoContent>
    <div class="info-lead">
      <p>
        Certains emails partent sans que personne ne les envoie&nbsp;: à la
        création d'une demande, à l'envoi d'un devis, après un appel resté sans
        réponse. Cette liste dit lesquels, à qui ils partent et ce qui les
        déclenche &mdash; l'historique en bas de page garde la trace de chaque
        envoi réel.
      </p>
    </div>

    <div class="info-section">
      <h3><i class="fas fa-envelope-open-text"></i> Types de mails automatiques</h3>
      <p>Le système envoie automatiquement des emails dans les situations suivantes :</p>
      
      <div class="info-item">
        <div class="info-item-header">
          <strong>1. Confirmation de demande de devis</strong>
        </div>
        <div class="info-item-content">
          <p>Envoyé au <strong>client</strong> lorsqu'un nouveau devis est créé (statut "Demande de devis").</p>
          <p class="info-note">
            <i class="fas fa-info-circle"></i> Cet email confirme la réception de la demande et informe le client que l'équipe va l'étudier.
          </p>
        </div>
      </div>
      
      <div class="info-item">
        <div class="info-item-header">
          <strong>2. Relances au client pour signer son devis (J+7 et J+21)</strong>
        </div>
        <div class="info-item-content">
          <p>
            Envoyées au <strong>client</strong> 7 jours puis 21 jours après l'envoi du devis, tant qu'il est au
            statut "Devis envoyé – en attente de signature".
          </p>
          <p>
            Juste avant chaque envoi, le statut est revérifié : un devis signé, perdu ou repassé en appel de
            qualification ne reçoit pas la relance.
          </p>
          <p class="info-note">
            <i class="fas fa-info-circle"></i> Sur la fiche du devis, l'onglet « Mails automatiques » affiche
            au-dessus des mails envoyés la prochaine relance prévue, et celles qui ont été annulées avec la raison.
          </p>
        </div>
      </div>

      <div class="info-item">
        <div class="info-item-header">
          <strong>3. Rappels aux commerciaux</strong>
          <span class="info-badge" style="background-color: #f59e0b; color: white; padding: 2px 8px; border-radius: 4px; font-size: 0.75rem; margin-left: 8px;">DÉSACTIVÉ</span>
        </div>
        <div class="info-item-content">
          <p>Les emails de rappel aux commerciaux sont actuellement <strong>désactivés</strong> :</p>
          <ul>
            <li><strong>Appel de qualification (J+2)</strong> : Rappel 2 jours après l'assignation d'un devis</li>
            <li><strong>Relance J+3</strong> : Rappel 3 jours après le passage au statut "Devis envoyé – en attente de signature"</li>
            <li><strong>Relance J+7</strong> : Rappel 7 jours après le passage au statut "Devis envoyé – en attente de signature"</li>
            <li><strong>Relance J+14</strong> : Rappel 14 jours après le passage au statut "Devis envoyé – en attente de signature"</li>
            <li><strong>Relance J+21 (3 semaines)</strong> : Rappel 21 jours après le passage au statut "Devis envoyé – en attente de signature"</li>
            <li><strong>Relance J+30 (1 mois)</strong> : Rappel 30 jours après le passage au statut "Devis envoyé – en attente de signature"</li>
          </ul>
          <p class="info-note">
            <i class="fas fa-bell"></i> Les notifications dans l'application continuent d'être créées pour informer les commerciaux des rappels, mais aucun email n'est envoyé.
          </p>
        </div>
      </div>
      
      <div class="info-item">
        <div class="info-item-header">
          <strong>4. Tentative d'appel - "Nous avons essayé de vous joindre"</strong>
        </div>
        <div class="info-item-content">
          <p>Envoyé au <strong>client</strong> lorsque le résultat d'un appel est :</p>
          <ul>
            <li>"Ne répond pas"</li>
            <li>"Numéro incorrect"</li>
          </ul>
          <p class="info-note">
            <i class="fas fa-info-circle"></i> Cet email informe le client que vous avez tenté de le joindre 
            et l'invite à vous contacter pour finaliser sa demande.
          </p>
        </div>
      </div>
    </div>
    
    <div class="info-section">
      <h3><i class="fas fa-cog"></i> Préférences utilisateur</h3>
      <p>Les commerciaux peuvent personnaliser quels emails automatiques ils souhaitent recevoir :</p>
      <ul>
        <li>Activation/désactivation globale des emails</li>
        <li>Activation/désactivation par type de notification (assignation, changement de statut, commentaires, etc.)</li>
      </ul>
      <p class="info-note">
        <i class="fas fa-info-circle"></i> Les emails de relance aux commerciaux (J+2, J+3, J+7, J+14, J+21, J+30) sont désactivés au niveau système.
      </p>
    </div>
    
    <div class="info-section">
      <h3><i class="fas fa-history"></i> Historique</h3>
      <p>Tous les emails automatiques envoyés sont enregistrés dans cette section avec :</p>
      <ul>
        <li>La date et l'heure d'envoi</li>
        <li>Le type d'email</li>
        <li>Le destinataire</li>
        <li>Le sujet de l'email</li>
      </ul>
    </div>
  </InfoContent>
</template>

<script setup>
import InfoContent from './InfoContent.vue'

defineEmits(['close'])
</script>

